module.exports = require("././jquery.html5-placeholder-shim.js");


//////////////////
// WEBPACK FOOTER
// jquery-html5-placeholder-shim (bower component)
// module id = 35
// module chunks = 0